<template>
  <div class="form-config-form main-content-cj h-100 mh-100">
    <b-container class="d-flex flex-column h-100 mh-100">
      <div class="main-header">
        <b-row class="align-items-center">
          <b-col cols="12" md="6" class="d-flex align-content-center">
            <span class="title">Configurar Formulário</span>
          </b-col>
        </b-row>
        <hr class="mb-0">
      </div>
      <div class="box-container">
        <validation-observer ref="formConfigForm" v-slot="{ invalid }">
          <b-row class="mb-3">
            <b-col cols="12">
              <div class="box-cj">
                <div class="header">
                  <p class="title">Configurações gerais</p>
                </div>
                <div class="content">
                  <b-row class="mb-3">
                    <b-col>
                      <label class="cj-label">Nome</label>
                      <validation-provider name="nome" :rules="{ required: true }" v-slot="{ errors }">
                        <b-form-input type="text" v-model="formConfigForm.name" :disabled="!((formConfigForm.id == null && canAdd) || (formConfigForm.id != null && canEdit))" :class="{ 'error': errors.length > 0 }"></b-form-input>
                        <span class="cj-error">{{ errors[0] }}</span>
                      </validation-provider>
                    </b-col>
                    <b-col>
                      <label class="cj-label">Status</label>
                      <validation-provider name="status" :rules="{ required: true }" v-slot="{ errors }">
                        <multiselect v-model="formConfigForm.enabled" :options="status" track-by="name" label="name" :preselectFirst="true" :showLabels="false" :allowEmpty="false" :searchable="false" :disabled="!((formConfigForm.id == null && canAdd) || (formConfigForm.id != null && canEdit))" placeholder="Status"></multiselect>
                        <span class="cj-error">{{ errors[0] }}</span>
                      </validation-provider>
                    </b-col>
                  </b-row>
                  <b-row class="mb-2">
                    <b-col>
                      <div class="pretty p-switch p-fill">
                        <input type="checkbox" v-model="formConfigForm.save_as_model" />
                        <div class="state p-success">
                          <label><span>Deixar disponível como modelo</span></label>
                        </div>
                      </div>
                    </b-col>
                  </b-row>
                </div>
                <div class="footer" v-if="((formConfigForm.id == null && canAdd) || (formConfigForm.id != null && canEdit))">
                  <b-button variant="primary" class="mr-3" @click="saveForm" :disabled="!canPerformAction || !((formConfigForm.id == null && canAdd) || (formConfigForm.id != null && canEdit))">Salvar</b-button>
                  <b-button variant="danger" v-if="formConfigForm.id != null && canRemove" @click="deleteForm">Excluir</b-button>
                </div>
              </div>
            </b-col>
          </b-row>

          <b-row class="mb-3">
            <b-col cols="12">
              <div class="box-cj">
                <div class="header">
                  <p class="title">Configuração de campos</p>
                </div>
                <div class="content">
                  <validation-observer ref="preFieldForm" v-slot="{ invalid }" :disabled="true">
                    <b-row>
                      <b-col cols="6" offset="3">
                        <b-row>
                          <b-col cols="8">
                            <validation-provider name="tipo de campo" :rules="{ required: true }" v-slot="{ errors }">
                              <multiselect v-model="inputType" :options="inputTypes" track-by="name" label="name" :showLabels="false" :searchable="false" placeholder="Selecione um tipo de campo" :class="{ 'error': errors.length > 0 }" :disabled="!((formConfigForm.id == null && canAdd) || (formConfigForm.id != null && canEdit))"></multiselect>
                              <span class="cj-error">{{ errors[0] }}</span>
                            </validation-provider>
                          </b-col>
                          <b-col>
                            <b-button variant="primary" block class="mr-3" @click="openFieldModal" :disabled="!canPerformAction || !((formConfigForm.id == null && canAdd) || (formConfigForm.id != null && canEdit))">Adicionar</b-button>
                          </b-col>
                        </b-row>
                      </b-col>
                    </b-row>
                  </validation-observer>
                  <hr>
                  <b-row>
                    <b-col v-for="(field, index) in fields" :key="field.id" :md="field.cols" :order="field.order" class="mb-2">
                      <div class="field" @click="editField(index)">
                        <FormField :field="field" :readonly="true"></FormField>

                        <div class="edit" v-if="((formConfigForm.id == null && canAdd) || (formConfigForm.id != null && canEdit))">
                          <i class="far fa-pencil-alt mr-2"></i> Clique para editar
                        </div>
                      </div>
                    </b-col>
                  </b-row>
                </div>
                <div class="footer" v-if="((formConfigForm.id == null && canAdd) || (formConfigForm.id != null && canEdit))">
                  <b-button variant="primary" class="mr-3" @click="saveForm" :disabled="!canPerformAction || !((formConfigForm.id == null && canAdd) || (formConfigForm.id != null && canEdit))">Salvar</b-button>
                </div>
              </div>
            </b-col>
          </b-row>
        </validation-observer>
      </div>
    </b-container>

    <b-modal id="field-modal" class="field-modal" size="lg" :modalClass="'field-modal'" @hidden="resetFieldModal">
      <template slot="modal-header">
        Adicionar novo campo
      </template>
      <template slot="default">
        <validation-observer ref="fieldForm" v-slot="{ invalid }">
          <b-container>
            <b-row class="mb-2">
              <b-col>
                <label class="cj-label">Tipo do campo</label>
                <validation-provider name="tipo de campo" :rules="{ required: true }" v-slot="{ errors }">
                  <multiselect v-model="fieldForm.type" :options="inputTypes" track-by="name" label="name" :showLabels="false" :allowEmpty="false" :searchable="false" placeholder="Selecione um tipo de campo" :class="{ 'error': errors.length > 0 }"></multiselect>
                  <span class="cj-error">{{ errors[0] }}</span>
                </validation-provider>
              </b-col>
              <b-col>
                <label class="cj-label">Nome do campo</label>
                <validation-provider name="nome" :rules="{ required: true }" v-slot="{ errors }">
                  <b-form-input type="text" v-model="fieldForm.name" :class="{ 'error': errors.length > 0 }"></b-form-input>
                  <span class="cj-error">{{ errors[0] }}</span>
                </validation-provider>
              </b-col>
            </b-row>
            <b-row class="mb-2">
              <b-col v-if="false">
                <label class="cj-label">Ordem</label>
                <validation-provider name="ordem" :rules="{ required: true }" v-slot="{ errors }">
                  <multiselect v-model="fieldForm.order" :options="orderOptions" track-by="name" label="name" :showLabels="false" :allowEmpty="false" :searchable="false" placeholder="Ordem do campo"  :class="{ 'error': errors.length > 0 }"></multiselect>
                  <span class="cj-error">{{ errors[0] }}</span>
                </validation-provider>
              </b-col>
              <b-col v-if="fieldForm.type != 'boolean' && fieldForm.type.value != 'attachments'">
                <label class="cj-label">Obrigatório?</label>
                <validation-provider name="obrigatório" :rules="{ required: true }" v-slot="{ errors }">
                  <multiselect v-model="fieldForm.required" :options="requiredOptions" track-by="name" label="name" :showLabels="false" :allowEmpty="false" :searchable="false" placeholder="Campo obrigatório?"  :class="{ 'error': errors.length > 0 }"></multiselect>
                  <span class="cj-error">{{ errors[0] }}</span>
                </validation-provider>
              </b-col>
              <b-col v-if="fieldForm.type.value != 'attachments'">
                <label class="cj-label">Largura</label>
                <validation-provider name="largura" :rules="{ required: true }" v-slot="{ errors }">
                  <multiselect v-model="fieldForm.cols" :options="colsOptions" track-by="name" label="name" :showLabels="false" :allowEmpty="false" :searchable="false" placeholder="Largura do campo"  :class="{ 'error': errors.length > 0 }"></multiselect>
                  <span class="cj-error">{{ errors[0] }}</span>
                </validation-provider>
              </b-col>
              <b-col v-if="fieldForm.type.value == 'long-text'">
                <label class="cj-label">Altura</label>
                <validation-provider name="altura" :rules="{ required: true }" v-slot="{ errors }">
                  <b-form-input type="number" min="5" step="1" v-model="fieldForm.rows" :class="{ 'error': errors.length > 0 }"></b-form-input>
                  <span class="cj-error">{{ errors[0] }}</span>
                </validation-provider>
              </b-col>
            </b-row>
            <b-row class="mb-2" v-if="fieldForm.type.value == 'short-text' || fieldForm.type.value == 'long-text'">
              <b-col>
                <label class="cj-label">Texto padrão</label>
                <b-input-group class="mb-2">
                  <b-input-group-prepend is-text>
                    <input type="checkbox" v-model="fieldForm.has_default_value">
                  </b-input-group-prepend>
                  <b-form-input v-model="fieldForm.default_value" :readonly="!fieldForm.has_default_value" v-if="fieldForm.type.value == 'short-text'"></b-form-input>
                  <b-form-textarea v-model="fieldForm.default_value" :readonly="!fieldForm.has_default_value" v-if="fieldForm.type.value == 'long-text'"></b-form-textarea>
                </b-input-group>
              </b-col>
            </b-row>
            <div v-if="fieldForm.type.value == 'multiple-choice' || fieldForm.type.value == 'list'">
              <hr>
              <h6 class="mb-3">Possíveis opções</h6>
              <b-row class="mb-2">
                <b-col cols="8" offset="2">
                  <validation-observer ref="optionForm" v-slot="{ invalid }" :disabled="true">
                  <b-row>
                    <b-col cols="8">
                      <validation-provider name="opção" :rules="{ required: true, regex: '^((?!\;).)*$' }" v-slot="{ errors }">
                        <b-form-input v-model="option" placeholder="Opção..."></b-form-input>
                        <span class="cj-error">{{ errors[0] }}</span>
                      </validation-provider>
                    </b-col>
                    <b-col>
                      <b-button variant="primary" block class="mr-3" @click="addOption" :disabled="!canPerformAction">Adicionar</b-button>
                    </b-col>
                  </b-row>
                  </validation-observer>
                </b-col>
              </b-row>
              <b-row class="mb-2">
                <b-col>
                  <draggable v-model="fieldForm.options" group="people" @start="drag=true" @end="drag=false" tag="b-list-group">
                    <b-list-group-item v-for="(option, index) in fieldForm.options" :key="index" class="d-flex justify-content-between align-items-center">
                      {{ option }}
                      <b-button variant="danger" @click="removeOption(index)"><i class="far fa-trash"></i></b-button>
                    </b-list-group-item>
                  </draggable>
                </b-col>
              </b-row>
            </div>
          </b-container>
        </validation-observer>
      </template>
      <template slot="modal-footer">
        <b-button size="sm" @click="$bvModal.hide('field-modal')">Fechar</b-button>

        <b-button-group size="sm">
          <b-button variant="danger" v-if="fieldForm.id != null" @click="removeField(fieldForm.id)">Remover</b-button>
          <b-button variant="success" @click="addField">{{ (fieldForm.id == null?'Adicionar':'Editar') }}</b-button>
        </b-button-group>
      </template>
    </b-modal>

    <div class="printable" v-if="user && this.fields.length > 0">
      <div class="text-center mb-5">
        <h3 class="text-center">{{ formConfigForm.name }}</h3>
        <h5 class="text-center">Impresso em <b>{{ moment().format('DD/MM/YYYY HH:mm')}}</b> por <b>{{ user.name }}</b></h5>
      </div>
      <div class="mt-3 fields">
        <div v-for="field in getFieldsInOrder()" :key="field.id" class="field" :class="'field-'+field.cols">
          <FormField :field="field" :readonly="true" :printable="true"></FormField>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

  export default {
    data() {
      return {
        leavingPage: false,
        user: null,

        canSee: true,
        canAdd: true,
        canEdit: true,
        canRemove: true,
        canPerformAction: true,


        formConfigForm: {
          id: null,
          name: '',
          order: 0,
          enabled: { value: true, name: 'Habilitado' },
          save_as_model: false
        },

        status: [
          { value: true, name: 'Habilitado' },
          { value: false, name: 'Desabilitado' }
        ],

        inputType: null,
        inputTypes: [
          { value: 'short-text', name: 'Texto curto' },
          { value: 'long-text', name: 'Texto longo' },
          { value: 'multiple-choice', name: 'Múltipla escolha' },
          { value: 'list', name: 'Lista' },
          { value: 'date', name: 'Data' },
          { value: 'boolean', name: 'Verdadeiro / Falso' },
          { value: 'attachments', name: 'Anexos' }
        ],

        fieldForm: {
          id: null,
          type: null,
          name: '',
          order: { value: 0, name: 0 },
          required: { value: false, name: 'Não' },
          options: [],
          has_default_value: false,
          default_value: '',
          cols: { value: 6, name: '50%' },
          rows: 5,
          new: true
        },

        orderOptions: [],

        requiredOptions: [
          { value: true, name: 'Sim' },
          { value: false, name: 'Não' }
        ],

        colsOptions: [
          { value: 3, name: '25%' },
          { value: 4, name: '33%' },
          { value: 6, name: '50%' },
          { value: 9, name: '75%' },
          { value: 12, name: '100%' }
        ],

        option: null,

        fields: []
      }
    },
    async mounted () {
      this.canSee = (this.helpers.isOwner())?true:this.helpers.checkPermission('forms', 'can_see');
      this.canAdd = (this.helpers.isOwner())?true:this.helpers.checkPermission('forms', 'can_add');
      this.canEdit = (this.helpers.isOwner())?true:this.helpers.checkPermission('forms', 'can_edit');
      this.canRemove = (this.helpers.isOwner())?true:this.helpers.checkPermission('forms', 'can_remove');

      if(this.canSee == false) {
        this.$swal('Desculpe', 'Você não tem permissão para acessar este módulo!', 'error');
        this.$router.push({ path: '/' });
        return;
      }

      this.user = JSON.parse(localStorage.getItem('user'));

      for(let i = 0; i <= 100; i++) {//alterado pra 100 pra evitar problemas no form (se tentar colocar mais que 21 campos, trava o form)
      // for(let i = 0; i <= 20; i++) {
        this.orderOptions.push({ value: i, name: i });
      }

      if (this.$route.params.id != 'novo-formulario') {
        this.eventBus.$emit('IS_LOADING', true);
        await this.api.getForm(this.$route.params.id).then(res => {
          this.eventBus.$emit('IS_LOADING', false);
          if(this.leavingPage) {
            return;
          }
          let formData = res.data;

          this.formConfigForm = {
            id: formData.id,
            name: formData.name,
            order: 0,
            enabled: this.status.find(status => status.value === formData.enabled),
            save_as_model: false
          };

          this.fields = formData.fields.map(field => {
            delete field.form_id;
            delete field.created_at;
            delete field.updated_at;
            delete field.deleted_at;

            if(field.options == null)
              field.options = '';

            if(field.default_value == null)
              field.default_value = '';

            field.value = field.default_value;

            if(field.type == 'attachments')
              field.value = [{name:'',value:'',file:''}];

            if(field.type == 'multiple-choice')
              field.value = [];

            return field;
          });
          this.fields.sort((a, b) => (a.order > b.order)?1:-1);
          let fieldNormalizedOrder = 0;
          this.fields.forEach(field => {
            field.order = fieldNormalizedOrder;
            fieldNormalizedOrder++;
          });

          if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
            console.log('Response Form', res);
        }).catch(err => {
          this.eventBus.$emit('IS_LOADING', false);
          if(this.leavingPage) {
            return;
          }
          this.$router.push({path: '/prontuarios'});

          this.$swal('Ops...', 'Não conseguimos carregar o modelo de formulário! Por favor, entre em contato com o suporte!', 'error');
          if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
            console.log('Error Form', err.response);
        });
      }
    },
    methods: {
      async saveForm() {
        if(!this.canPerformAction)
          return false;

        this.canPerformAction = false;

        const isValid = await this.$refs.formConfigForm.validate();
        if(!isValid) {
          this.canPerformAction = true;
          return false;
        }

        if((this.formConfigForm.id == null && this.canAdd) || (this.formConfigForm.id != null && this.canEdit)) {
          let formData = {
            id: this.formConfigForm.id,
            name: this.formConfigForm.name,
            enabled: this.formConfigForm.enabled.value,
            save_as_model: this.formConfigForm.save_as_model
          };

          formData.fields = this.fields;

          this.eventBus.$emit('IS_LOADING', true);
          if (this.formConfigForm.id == null) {
            this.api.storeForm(formData).then(res => {
              this.eventBus.$emit('IS_LOADING', false);
              this.canPerformAction = true;

              if (res.status == 201) {
                this.$swal('Uhull \\o/', 'O modelo de formulário foi criado com sucesso!', 'success').then(() => {
                  this.$router.push({path: '/prontuarios'});
                });
              } else {
                this.$swal('Ops...', 'Ocorreu um erro ao criar o modelo de formulário! Por favor, tente novamente. Caso o problema persista entre em contato com o suporte!', 'error');
              }

              if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
                console.log('Response Store Form', res);
            }).catch(err => {
              this.eventBus.$emit('IS_LOADING', false);
              this.canPerformAction = true;

              let msg = 'Não conseguimos criar este modelo de formulário! Por favor, tente novamente. Caso o problema persista entre em contato com o suporte!';

              switch (err.response.status) {
                case 422: msg = err.response.data.errors.join('\r\n'); break;
              }

              this.$swal('Ops...', msg, 'error');
              if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
                console.log('Error Store Form', err.response);
            });
          } else {
            this.api.updateForm(this.formConfigForm.id, formData).then(res => {
              this.eventBus.$emit('IS_LOADING', false);
              this.canPerformAction = true;

              if (res.status == 200) {
                this.$swal('Uhull \\o/', 'O modelo de formulário foi atualizado com sucesso!', 'success').then(() => {
                  this.$router.push({path: '/prontuarios'});
                });
              } else {
                this.$swal('Ops...', 'Ocorreu um erro ao atualizar o modelo de formulário! Por favor, tente novamente. Caso o problema persista entre em contato com o suporte!', 'error');
              }

              if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
                console.log('Response Update Form', res);
            }).catch(err => {
              this.eventBus.$emit('IS_LOADING', false);
              this.canPerformAction = true;

              let msg = 'Não conseguimos atualizar este modelo de formulário! Por favor, tente novamente. Caso o problema persista entre em contato com o suporte!';

              switch (err.response.status) {
                case 422: msg = err.response.data.errors.join('\r\n'); break;
              }

              this.$swal('Ops...', msg, 'error');
              if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
                console.log('Error Update Form', err.response);
            });
          }
        }
      },

      deleteForm() {
        if(this.canRemove) {
          this.$swal({
            title: 'Você tem certeza?',
            text: 'Esta ação não poderá ser desfeita!',
            type: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Excluir modelo de formulário',
            cancelButtonText: 'Cancelar',
            focusCancel: true
          }).then((res) => {
            if(res.value) {
              this.eventBus.$emit('IS_LOADING', true);
              this.canPerformAction = false;
              this.api.deleteForm(this.formConfigForm.id).then(res => {
                this.eventBus.$emit('IS_LOADING', false);
                this.canPerformAction = true;
                if (res.status == 204) {
                  this.$swal('Uhull \\o/', 'O modelo de formulário foi excluído com sucesso!', 'success').then(() => {
                    this.$router.push({path: '/prontuarios'});
                  });
                } else {
                  this.$swal('Ops...', 'Ocorreu um erro ao excluir o modelo de formulário! Por favor, tente novamente. Caso o problema persista entre em contato com o suporte!', 'error')
                }

                if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
                  console.log('Response Delete Form', res);
              }).catch(err => {
                this.eventBus.$emit('IS_LOADING', false);
                this.canPerformAction = true;
                this.$swal('Ops...', 'Não conseguimos excluir este modelo de formulário! Por favor, tente novamente. Caso o problema persista entre em contato com o suporte!', 'error');
                if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
                  console.log('Error Delete Form', err.response);
              });
            }
          });
        }
      },

      async openFieldModal() {
        if(!this.canPerformAction)
          return false;

        this.canPerformAction = false;

        const isValid = await this.$refs.preFieldForm.validate();
        if(!isValid) {
          this.canPerformAction = true;
          return false;
        }

        let currentOrder = -1;
        if(this.fields.length > 0)
          currentOrder = this.fields[this.fields.length - 1].order;
        let fieldOrder = this.orderOptions.find(order => order.value === currentOrder+1);
        if(fieldOrder === undefined) {
          this.canPerformAction = true;
          this.$swal('Desculpe', 'Não é possível adicionar mais campos!', 'error');
          return false;
        }

        if((this.formConfigForm.id == null && this.canAdd) || (this.formConfigForm.id != null && this.canEdit)) {
          this.canPerformAction = true;
          this.fieldForm.type = this.inputType;
          this.fieldForm.order = fieldOrder;
          this.$bvModal.show('field-modal');
          this.inputType = null;
          this.$refs.preFieldForm.reset();
        }
      },
      resetFieldModal() {
        this.fieldForm = {
          id: null,
          type: null,
          name: '',
          order: { value: 0, name: 0 },
          required: { value: false, name: 'Não' },
          options: [],
          has_default_value: false,
          default_value: '',
          cols: { value: 6, name: '50%' },
          rows: 5,
          new: true
        };
      },
      async addField() {
        if(!this.canPerformAction)
          return false;

        this.canPerformAction = false;

        const isValid = await this.$refs.fieldForm.validate();
        if(!isValid) {
          this.canPerformAction = true;
          return false;
        }

        let fieldData = {
          id: this.fieldForm.id,
          type: this.fieldForm.type.value,
          name: this.fieldForm.name,
          order: this.fieldForm.order.value,
          required: this.fieldForm.required.value,
          options: this.fieldForm.options.join(';'),
          default_value: this.fieldForm.default_value,
          value: this.fieldForm.default_value,
          cols: this.fieldForm.cols.value,
          rows: this.fieldForm.rows,
          new: this.fieldForm.new
        };
        if(fieldData.type == 'attachments') {
          fieldData.value = [{name:'',value:'',file:''}];
          fieldData.cols = 12;
        }
        if(fieldData.type == 'multiple-choice') {
          fieldData.value = [];
        }

        if(fieldData.id == null) {
          fieldData.id = this.helpers.uuidv4();

          this.fields.push(fieldData);
        } else {
          this.fields = this.fields.map(field => {
            if(field.id == fieldData.id)
              field = fieldData;

            return field;
          });
        }

        this.fields.sort((a, b) => (a.order > b.order)?1:-1);

        this.$bvModal.hide('field-modal');
        this.canPerformAction = true;
      },
      async editField(index) {
        if(!this.canPerformAction)
          return false;

        this.canPerformAction = false;

        let field = this.fields[index];

        this.fieldForm = {
          id: field.id,
          type: this.inputTypes.find(type => type.value === field.type),
          name: field.name,
          order: this.orderOptions.find(order => order.value === field.order),
          required: this.requiredOptions.find(required => required.value === field.required),
          options: (field.options.indexOf(';') > -1)?field.options.split(';'):(field.options != '')?[ field.options ]:[],
          has_default_value: (field.default_value != ''),
          default_value: field.default_value,
          cols: this.colsOptions.find(col => col.value === field.cols),
          rows: field.rows,
          new: field.hasOwnProperty('new')?field.new:false
        };

        this.$bvModal.show('field-modal');
        this.canPerformAction = true;
      },
      async removeField(fieldId) {
        if(!this.canPerformAction)
          return false;

        this.canPerformAction = false;

        this.fields = this.fields.filter(field => {
          return field.id != fieldId
        });

        this.$bvModal.hide('field-modal');
        this.canPerformAction = true;
      },
      async addOption() {
        if(!this.canPerformAction)
          return false;

        this.canPerformAction = false;

        const isValid = await this.$refs.optionForm.validate();
        if(!isValid) {
          this.canPerformAction = true;
          return false;
        }

        this.canPerformAction = true;
        this.fieldForm.options.push(this.option);
        this.option = null;
        this.$refs.optionForm.reset();
      },
      async removeOption(index) {
        if(!this.canPerformAction)
          return false;

        this.canPerformAction = false;
        await this.fieldForm.options.splice(index, 1);
        this.canPerformAction = true;
      },
      getFieldsInOrder() {
        let fields = this.helpers.clone(this.fields);

        return fields.sort((a, b) => {
          if(a.order < b.order) return -1;
          if(a.order > b.order) return 1;
          return 0;
        });
      }
    },
    beforeRouteLeave (to, from, next) {
      this.leavingPage = true;
      next();
    }
  }
</script>

<style lang="scss">
  .form-config-form {
    padding: 20px 0;

    .field {
      position: relative;

      .edit {
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.8);
        opacity: 0;
        top: 0;
        left: 0;
        font-size: 0.8em;
        position: absolute;
        color: #ffffff;
        display: flex;
        align-items: center;
        justify-content: center;
        transition: all 0.5s;
        cursor: pointer;
        z-index: 5;
      }

      &:hover {
        .edit {
          opacity: 1;
        }
      }
    }

    .printable {
      display: none;
    }

    @media print {
      & > .container, .box-fullcalendar {
        display: none !important;
      }

      .printable {
        display: block;
        padding: 20px;

        .fields {
          position: relative;

          .field {
            position: relative;
            display: inline-block;
            margin: 10px 15px;
            border: 1px solid #000000;
            border-radius: 0;
            background-color: #ffffff;
            padding: 15px 15px;
            page-break-after: auto;
            page-break-inside: avoid;

            &.field-3 { width: calc(25% - 30px); }
            &.field-4 { width: calc(33% - 30px); }
            &.field-6 { width: calc(50% - 30px); }
            &.field-9 { width: calc(75% - 30px); }
            &.field-12 { width: calc(100% - 30px); }

            label {
              position: absolute;
              top: -12px;
              left: 15px;
              background-color: #ffffff;
              padding: 3px 5px;
              color: #000000;
            }

            textarea {
              resize: none;
            }

            .form-control {
              border: none;
              background-color: transparent;
              padding: 0;
            }
          }
        }
      }
    }
  }
</style>
